<template>
    <form class="form two gcrg20" @submit="checkForm">
        <div class="input-group col2-span" v-if="typeof validationErrors !== 'undefined'">
            <div class="col-12">
                <p>There were some errors in your submission:</p>
                <li v-for="(value,key,index) in validationErrors">
                    {{ value[0] }}
                </li>
            </div>
        </div>

        <div class="input-group grg10">
            <input
                    v-model="ad.name"
                    type="text"
                    :class="`form-control '  ${typeof validationErrors !== 'undefined' && validationErrors.name ? ' is-invalid' : ''}`"
                    name="name"
                    id="name"
                    placeholder="Name*"
            >
            <lara-error v-if="typeof validationErrors !== 'undefined'" :validation-error="validationErrors.name"></lara-error>
        </div>
        <div class="input-group grg10">
            <input
                    v-model="ad.email"
                    type="text"
                    class="form-control"
                    :class="`form-control '  ${typeof validationErrors !== 'undefined' && validationErrors.email ? ' is-invalid' : ''}`"
                    placeholder="Email*"
            >
            <lara-error v-if="typeof validationErrors !== 'undefined'" :validation-error="validationErrors.email"></lara-error>
        </div>
        <div class="input-group grg10 col2-span">
            <input
                    v-model="ad.phone_number"
                    type="text"
                    :class="`form-control '  ${typeof validationErrors !== 'undefined' && validationErrors.phone_number ? ' is-invalid' : ''}`"
                    name="phone_number"
                    id="phone_number"
                    placeholder="Phone Number*"
            >
            <lara-error v-if="typeof validationErrors !== 'undefined'" :validation-error="validationErrors.phone_number"></lara-error>
        </div>
        <div class="input-group grg10 col2-span">
            <textarea
                    v-model="ad.message"
                    type="text"
                    :class="`comment form-control '  ${typeof validationErrors !== 'undefined' && validationErrors.message ? ' is-invalid' : ''}`"
                    name="message"
                    id="message"
                    placeholder="Message"
            />
            <lara-error v-if="typeof validationErrors !== 'undefined'" :validation-error="validationErrors.message"></lara-error>
        </div>

        <div class="button">
            <button type="submit" class="primary rounded jstart">Submit</button>
        </div>
    </form>
</template>

<script>
    import LaraError from "../general/LaraError";

    export default {
        name: "AdForm",
        components: {
            LaraError,
        },
        data: () => ({
            ad: {
                name: '',
                email: '',
                phone_number: '',
                message: ''
            },
            submitted: false,
            validationErrors: undefined
        }),
        methods: {
            checkForm(e) {
                this.validationErrors = undefined;
                this.submitted = true;
                e.preventDefault();
                axios.post('/ad', this.ad).then(response => {
                    if (response.data.message === 'Form submitted successfully') {
                        this.showAlert();
                        this.ad = {};
                    }
                }).catch(errors => {
                    if (errors.response.status === 422) {
                        console.log(errors, errors.response.data, errors.response.data.errors);
                        this.validationErrors = errors.response.data.errors;
                        this.validationMessage = errors.response.data.message;
                        this.submitted = false;
                    }
                });
            },
            showAlert() {
                this.$swal.fire({
                    icon: 'success',
                    title: 'Thank you!',
                    html: 'Your request has been submitted successfully. We will get back to you soon.',
                });
            }
        }
    }
</script>

<style scoped>

</style>
